import styled from 'styled-components'

export const ComingSoonOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: inherit;
  backdrop-filter: blur(4px);
  background: rgba(0, 0, 0, 0.18);
  z-index: 10;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textColor};
  pointer-events: none;
`

export const HrDashboardTitleLine = styled.div<{
  smallPaddingBottom?: boolean
  marginTop?: string
  overflow?: boolean
}>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f520;
  ${(props) => props.smallPaddingBottom && 'padding-bottom: 0px;'}
  ${(props) => props.marginTop && `margin-top: ${props.marginTop};`}
  ${(props) => props.overflow && 'overflow: visible;'}
`
export const HrDashboardInnerWidgetContainer = styled.div<{ padding?: string; overflow?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.padding || '0 8px'};
  overflow: ${(props) => (props.overflow ? 'visible' : 'hidden')};

  &:hover {
    overflow-y: auto; /* Only vertical */
    overflow-x: hidden; /* Disable horizontal */
  }

  @media (max-width: 1200px) {
    height: auto;
    overflow: unset;
  }

  & > div {
    .widget-notification {
      @media (max-width: 1200px) {
        flex-direction: column;
        align-items: start;
        gap: 5px;

        .time {
          color: #ff9900;
        }
      }
    }
  }
`
